import * as React from 'react';

import { getTranslation, keys } from '../../../Resources/Translations';
import { InfoLabel } from '../../Blocks/Banners/InfoLabel.csharp';
import { CheapestForFreeDiscountViewModel } from '../../Blocks/CheapestForFreeDiscount/CheapestForFreeDiscountViewModel.csharp';
import { DiscountType } from '../../Blocks/DiscountType.csharp';
import { DiscountVariant } from '../../Blocks/DiscountVariant.csharp';
import { ProductDiscountViewModel } from '../../Blocks/ProductDiscount/ProductDiscountViewModel.csharp';
import { IPromotionInfo } from '../../Marketing/Promotions/PromotionInfo/IPromotionInfo.csharp';
import { CircleInfoLabel, StarInfoLabelColor } from './CircleInfoLabel';
import { NewProductInfoLabel } from './NewProductInfoLabel';

export const renderInfoLabel = (discount?: IPromotionInfo, discountVariant?: DiscountVariant, label?: InfoLabel) => {
    if (discount) {
        return renderDiscount(discount, discountVariant ?? DiscountVariant.Medium);
    } else if (label) {
        switch (label) {
            case InfoLabel.NewItem:
                return <NewProductInfoLabel variant={DiscountVariant.Small} />;
            case InfoLabel.LowPrice:
                return (
                    <CircleInfoLabel
                        color={StarInfoLabelColor.Pink}
                        variant={DiscountVariant.Small}
                        value={getTranslation(keys['enum.infoBanner.lowPrice2'])}
                        additionalInfo={getTranslation(keys['enum.infoBanner.lowPrice1'])}
                    />
                );
            default:
                return null;
        }
    }

    return null;
};

export const renderDiscount = (discount: IPromotionInfo, variant: DiscountVariant) => {
    switch (discount.type) {
        case DiscountType.Product: {
            const productDiscount = discount as ProductDiscountViewModel;

            return (
                <CircleInfoLabel
                    color={StarInfoLabelColor.Red}
                    variant={variant}
                    value={productDiscount.value}
                    additionalInfo={getTranslation(keys['productDiscount.upTo'])}
                />
            );
        }
        case DiscountType.CheapestForFree: {
            const cheapestDiscount = discount as CheapestForFreeDiscountViewModel;

            return (
                <CircleInfoLabel
                    color={StarInfoLabelColor.Red}
                    variant={variant}
                    value={`${cheapestDiscount.requiredQuantity} ${getTranslation(keys['cheapestForFreeDiscount.for'])} ${cheapestDiscount.paidQuantity}`}
                    requiredQuantity={cheapestDiscount.requiredQuantity}
                    paidQuantity={cheapestDiscount.paidQuantity}
                />
            );
        }
        default:
            return null;
    }
};
